import { useSelector } from "react-redux";
import { ObjectTypeEnum } from "../models/ObjectTypeEnum"


export default function useShareTypes() {

    const texts = useSelector(state => state.translate.texts);

    return () => {
        let studygroupNum = ObjectTypeEnum.StudyGroup
        let constStudyGroupNum = ObjectTypeEnum.ConstUserGroup
        let userNum = ObjectTypeEnum.User;
        let publicNum = ObjectTypeEnum.External;
        let data = {
            [studygroupNum]: texts.GroupFriends,
            [constStudyGroupNum]: texts.nationwideSharing,
            [userNum]: texts.specificFriends,
            [publicNum]: texts.sendExternal,
        }
        return data
    }

}